// Copyright (c) 2017 Deere & Company

import AuditSummaryReport from '@deere/cps-it.warranty-model-factory/lib/audit-summary';
import t from 'tcomb';

const Report = t.list(AuditSummaryReport, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/audit-summary/state/report.js